/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "bottom-bar bottom-options"
  }, [_vm.left.length > 0 ? _c('div', {
    staticClass: "left font-size-h4-normal",
    class: {
      flex1: _vm.right.length === 0
    }
  }, _vm._l(_vm.left, function (item) {
    return _c('div', {
      staticClass: "left-item",
      on: {
        "click": function ($event) {
          return _vm.$emit('on-click', item.name);
        }
      }
    }, [_c('div', {
      staticClass: "left-item-icon"
    }, [_c('img', {
      staticClass: "left-item-icon-i",
      attrs: {
        "src": "/spa_static_mobile/icon/" + item.icon + ".png",
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "left-item-text"
    }, [_vm._v(_vm._s(item.text))])]);
  }), 0) : _vm._e(), _vm.right.length > 0 ? _c('div', {
    staticClass: "right font-size-h3-large"
  }, _vm._l(_vm.right, function (item) {
    return _c('div', {
      staticClass: "right-item",
      on: {
        "click": function ($event) {
          return _vm.$emit('on-click', item.name);
        }
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 0) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };